document.addEventListener("DOMContentLoaded", function () {
  //---------- RADIO ----------
  if (document.querySelector(".radio")) {
    var playerTrack = document.getElementById("player_track");
    var sArea = document.getElementById("s_area");
    var seekBar = document.getElementById("seek_bar");
    var trackTime = document.getElementById("track_time");
    var insTime = document.getElementById("ins_time");
    var sHover = document.getElementById("s_hover");
    var playPauseButton = document.getElementById("play_pause_button");
    var icon = playPauseButton ? playPauseButton.querySelector("i") : null;
    var tProgress = document.getElementById("current_time");
    var tTime = document.getElementById("track_length");
    var playPreviousTrackButton = document.getElementById("play_previous");
    var playNextTrackButton = document.getElementById("play_next");
    var seekT;
    var seekLoc;
    var seekBarPos;
    var cM;
    var ctMinutes;
    var ctSeconds;
    var curMinutes;
    var curSeconds;
    var durMinutes;
    var durSeconds;
    var playProgress;
    var nTime = 0;
    var buffInterval = null;
    var tFlag = false;
    var currIndex = -1;
    var audio = new Audio();

    function setIconClass(className) {
      if (icon) {
        icon.className = className;
        icon.setAttribute("aria-hidden", "true");
      }
    }

    function playPause() {
      setTimeout(function () {
        if (audio.paused) {
          playerTrack.classList.add("active");
          checkBuffering();
          setIconClass("fa fa-pause");
          audio.play();
        } else {
          playerTrack.classList.remove("active");
          clearInterval(buffInterval);
          setIconClass("fa fa-play");
          audio.pause();
        }
      }, 300);
    }

    function showHover(event) {
      seekBarPos = sArea.getBoundingClientRect();
      seekT = event.clientX - seekBarPos.left;
      seekLoc = audio.duration * (seekT / sArea.offsetWidth);
      sHover.style.width = seekT + "px";
      cM = seekLoc / 60;
      ctMinutes = Math.floor(cM);
      ctSeconds = Math.floor(seekLoc - ctMinutes * 60);
      if (ctMinutes < 0 || ctSeconds < 0) {
        return;
      }
      if (ctMinutes < 0 || ctSeconds < 0) {
        return;
      }
      if (ctMinutes < 10) {
        ctMinutes = "0" + ctMinutes;
      }
      if (ctSeconds < 10) {
        ctSeconds = "0" + ctSeconds;
      }
      if (isNaN(ctMinutes) || isNaN(ctSeconds)) {
        insTime.textContent = "--:--";
      } else {
        insTime.textContent = ctMinutes + ":" + ctSeconds;
      }
      insTime.style.left = seekT + "px";
      insTime.style.marginLeft = "-21px";
      insTime.style.display = "block";
    }

    function hideHover() {
      sHover.style.width = "0";
      insTime.textContent = "00:00";
      insTime.style.left = "0px";
      insTime.style.marginLeft = "0px";
      insTime.style.display = "none";
    }

    function playFromClickedPos() {
      audio.currentTime = seekLoc;
      seekBar.style.width = seekT + "px";
    }

    function updateCurrTime() {
      nTime = new Date().getTime();
      if (!tFlag) {
        tFlag = true;
        trackTime.classList.add("active");
      }
      curMinutes = Math.floor(audio.currentTime / 60);
      curSeconds = Math.floor(audio.currentTime - curMinutes * 60);
      durMinutes = Math.floor(audio.duration / 60);
      durSeconds = Math.floor(audio.duration - durMinutes * 60);
      playProgress = (audio.currentTime / audio.duration) * 100;
      if (curMinutes < 10) {
        curMinutes = "0" + curMinutes;
      }
      if (curSeconds < 10) {
        curSeconds = "0" + curSeconds;
      }
      if (durMinutes < 10) {
        durMinutes = "0" + durMinutes;
      }
      if (durSeconds < 10) {
        durSeconds = "0" + durSeconds;
      }
      if (isNaN(curMinutes) || isNaN(curSeconds)) {
        tProgress.textContent = "00:00";
      } else {
        tProgress.textContent = curMinutes + ":" + curSeconds;
      }
      if (isNaN(durMinutes) || isNaN(durSeconds)) {
        tTime.textContent = "00:00";
      } else {
        tTime.textContent = durMinutes + ":" + durSeconds;
      }
      if (
        isNaN(curMinutes) ||
        isNaN(curSeconds) ||
        isNaN(durMinutes) ||
        isNaN(durSeconds)
      ) {
        trackTime.classList.remove("active");
      } else {
        trackTime.classList.add("active");
      }
      seekBar.style.width = playProgress + "%";
      if (playProgress === 100) {
        setIconClass("fa fa-play");
        seekBar.style.width = "0";
        tProgress.textContent = "00:00";
        clearInterval(buffInterval);
      }
    }

    function checkBuffering() {
      clearInterval(buffInterval);
      buffInterval = setInterval(function () {}, 100);
    }

    function selectTrack(flag) {
      if (flag === 0 || flag === 1) {
        ++currIndex;
      } else {
        --currIndex;
      }

      if (
        currIndex > -1 &&
        Array.isArray(window.trackUrl) &&
        currIndex < window.trackUrl.length
      ) {
        if (flag === 0) {
          setIconClass("fa fa-play");
        } else {
          setIconClass("fa fa-pause");
        }
        seekBar.style.width = "0";
        trackTime.classList.remove("active");
        tProgress.textContent = "00:00";
        tTime.textContent = "00:00";
        audio.src = window.trackUrl[currIndex];
        nTime = 0;
        if (flag !== 0) {
          audio.play();
          playerTrack.classList.add("active");
          clearInterval(buffInterval);
          checkBuffering();
        }
      } else if (flag === 0 || flag === 1) {
        --currIndex;
      } else {
        ++currIndex;
      }
    }

    audio.loop = false;
    selectTrack(0);
    playPauseButton.addEventListener("click", playPause);
    sArea.addEventListener("click", playFromClickedPos);
    sArea.addEventListener("mousemove", showHover);
    sArea.addEventListener("mouseout", hideHover);
    audio.addEventListener("timeupdate", updateCurrTime);

    if (playPreviousTrackButton) {
      playPreviousTrackButton.addEventListener("click", function () {
        selectTrack(-1);
      });
    }

    if (playNextTrackButton) {
      playNextTrackButton.addEventListener("click", function () {
        selectTrack(1);
      });
    }
  }
  //---------- END OF RADIO ----------

  //---------- VOICE ----------
  if (document.querySelector(".sorna_voice_land")) {
    var playerVoiceTrack = document.getElementById("player_voice_track");
    var sVoiceArea = document.getElementById("s_voice_area");
    var seekVoiceBar = document.getElementById("seek_voice_bar");
    var trackVoiceTime = document.getElementById("track_voice_time");
    var insVoiceTime = document.getElementById("ins_voice_time");
    var sVoiceHover = document.getElementById("s_voice_hover");
    var voicePlayPauseButton = document.getElementById(
      "play_pause_button_land",
    );
    var voiceIcon = voicePlayPauseButton
      ? voicePlayPauseButton.querySelector("i")
      : null;
    var tVoiceProgress = document.getElementById("voice_current_time");
    var tVoiceTime = document.getElementById("voice_track_length");
    var seekVoiceT;
    var seekVoiceLoc;
    var seekVoiceBarPos;
    var cMVoice;
    var ctMinutesVoice;
    var ctSecondsVoice;
    var curMinutesVoice;
    var curSecondsVoice;
    var durMinutesVoice;
    var durSecondsVoice;
    var playProgressVoice;
    var nTimeVoice = 0;
    var buffIntervalVoice = null;
    var tFlagVoice = false;
    var currIndexVoice = -1;
    var voiceAudio = new Audio();

    function setVoiceIconClass(className) {
      if (voiceIcon) {
        voiceIcon.className = className;
        voiceIcon.setAttribute("aria-hidden", "true");
      }
    }

    function playPauseVoice() {
      setTimeout(function () {
        if (voiceAudio.paused) {
          playerVoiceTrack.classList.add("active");
          checkBufferingVoice();
          setVoiceIconClass("fa fa-pause");
          voiceAudio.play();
        } else {
          playerVoiceTrack.classList.remove("active");
          clearInterval(buffIntervalVoice);
          setVoiceIconClass("fa fa-play");
          voiceAudio.pause();
        }
      }, 300);
    }

    function showHoverVoice(event) {
      seekVoiceBarPos = sVoiceArea.getBoundingClientRect();
      seekVoiceT = event.clientX - seekVoiceBarPos.left;
      seekVoiceLoc =
        voiceAudio.duration * (seekVoiceT / sVoiceArea.offsetWidth);
      sVoiceHover.style.width = seekVoiceT + "px";
      cMVoice = seekVoiceLoc / 60;
      ctMinutesVoice = Math.floor(cMVoice);
      ctSecondsVoice = Math.floor(seekVoiceLoc - ctMinutesVoice * 60);
      if (ctMinutesVoice < 0 || ctSecondsVoice < 0) {
        return;
      }
      if (ctMinutesVoice < 0 || ctSecondsVoice < 0) {
        return;
      }
      if (ctMinutesVoice < 10) {
        ctMinutesVoice = "0" + ctMinutesVoice;
      }
      if (ctSecondsVoice < 10) {
        ctSecondsVoice = "0" + ctSecondsVoice;
      }
      if (isNaN(ctMinutesVoice) || isNaN(ctSecondsVoice)) {
        insVoiceTime.textContent = "--:--";
      } else {
        insVoiceTime.textContent = ctMinutesVoice + ":" + ctSecondsVoice;
      }
      insVoiceTime.style.left = seekVoiceT + "px";
      insVoiceTime.style.marginLeft = "-21px";
      insVoiceTime.style.display = "block";
    }

    function hideHoverVoice() {
      sVoiceHover.style.width = "0";
      insVoiceTime.textContent = "00:00";
      insVoiceTime.style.left = "0px";
      insVoiceTime.style.marginLeft = "0px";
      insVoiceTime.style.display = "none";
    }

    function playFromClickedPosVoice() {
      voiceAudio.currentTime = seekVoiceLoc;
      seekVoiceBar.style.width = seekVoiceT + "px";
    }

    function updateCurrTimeVoice() {
      nTimeVoice = new Date().getTime();
      if (!tFlagVoice) {
        tFlagVoice = true;
        trackVoiceTime.classList.add("active");
      }
      curMinutesVoice = Math.floor(voiceAudio.currentTime / 60);
      curSecondsVoice = Math.floor(
        voiceAudio.currentTime - curMinutesVoice * 60,
      );
      durMinutesVoice = Math.floor(voiceAudio.duration / 60);
      durSecondsVoice = Math.floor(voiceAudio.duration - durMinutesVoice * 60);
      playProgressVoice = (voiceAudio.currentTime / voiceAudio.duration) * 100;
      if (curMinutesVoice < 10) {
        curMinutesVoice = "0" + curMinutesVoice;
      }
      if (curSecondsVoice < 10) {
        curSecondsVoice = "0" + curSecondsVoice;
      }
      if (durMinutesVoice < 10) {
        durMinutesVoice = "0" + durMinutesVoice;
      }
      if (durSecondsVoice < 10) {
        durSecondsVoice = "0" + durSecondsVoice;
      }
      if (isNaN(curMinutesVoice) || isNaN(curSecondsVoice)) {
        tVoiceProgress.textContent = "00:00";
      } else {
        tVoiceProgress.textContent = curMinutesVoice + ":" + curSecondsVoice;
      }
      if (isNaN(durMinutesVoice) || isNaN(durSecondsVoice)) {
        tVoiceTime.textContent = "00:00";
      } else {
        tVoiceTime.textContent = durMinutesVoice + ":" + durSecondsVoice;
      }
      if (
        isNaN(curMinutesVoice) ||
        isNaN(curSecondsVoice) ||
        isNaN(durMinutesVoice) ||
        isNaN(durSecondsVoice)
      ) {
        trackVoiceTime.classList.remove("active");
      } else {
        trackVoiceTime.classList.add("active");
      }
      seekVoiceBar.style.width = playProgressVoice + "%";
      if (playProgressVoice === 100) {
        setVoiceIconClass("fa fa-play");
        seekVoiceBar.style.width = "0";
        tVoiceProgress.textContent = "00:00";
        clearInterval(buffIntervalVoice);
      }
    }

    function checkBufferingVoice() {
      clearInterval(buffIntervalVoice);
      buffIntervalVoice = setInterval(function () {}, 100);
    }

    function selectTrackVoice(flag) {
      if (flag === 0 || flag === 1) {
        ++currIndexVoice;
      } else {
        --currIndexVoice;
      }

      if (
        currIndexVoice > -1 &&
        Array.isArray(window.voiceTrackUrl) &&
        currIndexVoice < window.voiceTrackUrl.length
      ) {
        if (flag === 0) {
          setVoiceIconClass("fa fa-play");
        } else {
          setVoiceIconClass("fa fa-pause");
        }
        seekVoiceBar.style.width = "0";
        trackVoiceTime.classList.remove("active");
        tVoiceProgress.textContent = "00:00";
        tVoiceTime.textContent = "00:00";
        voiceAudio.src = window.voiceTrackUrl[currIndexVoice];
        nTimeVoice = 0;
        if (flag !== 0) {
          voiceAudio.play();
          playerVoiceTrack.classList.add("active");
          clearInterval(buffIntervalVoice);
          checkBufferingVoice();
        }
      } else if (flag === 0 || flag === 1) {
        --currIndexVoice;
      } else {
        ++currIndexVoice;
      }
    }

    voiceAudio.loop = false;
    selectTrackVoice(0);
    voicePlayPauseButton.addEventListener("click", playPauseVoice);
    sVoiceArea.addEventListener("click", playFromClickedPosVoice);
    sVoiceArea.addEventListener("mousemove", showHoverVoice);
    sVoiceArea.addEventListener("mouseout", hideHoverVoice);
    voiceAudio.addEventListener("timeupdate", updateCurrTimeVoice);
  }
  //---------- END OF VOICE ----------

  var appClose = document.getElementById("app-close");
  if (appClose) {
    appClose.addEventListener("click", function () {
      var installApp = document.querySelector(".install-app");
      if (installApp) {
        installApp.style.display = "none";
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  //----- SEARCH -----
  var search = document.querySelector(".main_header .search_icon");
  if (search) {
    search.addEventListener("click", toggleSearch);
  }

  function toggleSearch(e) {
    e.preventDefault();
    e.stopPropagation();
    var searchForm = document.querySelector(".main_header #search_box");
    if (!searchForm) {
      return;
    }
    if (searchForm.style.display === "block") {
      searchForm.style.display = "none";
    } else {
      searchForm.style.display = "block";
    }
  }
  //----- END OF SEARCH -----

  // ----- MENU -----
  if (window.screen.width < 800) {
    var menu = document.querySelector(".main_nav .show_menu");
    if (menu) {
      menu.addEventListener("click", toggleMenu);
    }

    function toggleMenu() {
      var menuForm = document.querySelector("#nav_toggle");
      if (!menuForm) {
        return;
      }
      if (menuForm.style.display === "block") {
        menuForm.style.display = "none";
      } else {
        menuForm.style.display = "block";
      }
    }
    // ----- END OF MENU -----

    // ----- SUB_MENU -----
    var arrowIcon = document.querySelectorAll(".submenu_mobile_icn");
    arrowIcon.forEach(function (item) {
      item.addEventListener("click", toggleSubmenu);
    });

    function toggleSubmenu(e) {
      e.stopPropagation();
      e.preventDefault();
      if (!this.parentNode || !this.parentNode.children[2]) {
        return;
      }
      if (this.parentNode.children[2].style.display === "block") {
        this.parentNode.children[2].style.display = "none";
      } else {
        this.parentNode.children[2].style.display = "block";
      }
    }
    // ----- END OF SUB_MENU -----
  }

  // ----- MAIN PAGE SLIDER -----
  if (document.querySelector(".main_news")) {
    new Splide(".main_news", {
      autoplay: true,
      interval: 4000,
      type: "loop",
      direction: "rtl",
      adaptiveHeight: true,
    }).mount();
  }
  // ----- END OF MAIN PAGE SLIDER -----

  // ----- ARCHIVE ICON -----
  if (document.querySelector(".archive_news_type .flip")) {
    var archive = document.querySelector(".archive_news_type .flip");
    archive.addEventListener("click", toggleFlip);
    function toggleFlip() {
      var panel = document.querySelector(".archive_news_type .panel");
      if (!panel) {
        return;
      }
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    }
  }
  // ----- END OF ARCHIVE ICONS -----
});
